import { transparentize } from 'polished';
import { useCurrentUser } from '@bizzabo/entities';
import { UserIcon, UserFullName, UserJobDetails, ArrowRightSLine } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';

import useProfileAnalytics from '../../hooks/useProfileAnalytics';

type UserProfileProps = {
    eventId: number;
    onClick: () => void;
};

export const UserProfileMobileCTA: React.FC<UserProfileProps> = ({ eventId, onClick }) => {
    const { data: currentUser, isLoading, error } = useCurrentUser(eventId);
    const { sendMobileProfileOpen } = useProfileAnalytics();
    const classes = useStyles();

    const openUserProfile = () => {
        onClick();
        sendMobileProfileOpen();
    };

    if (isLoading || error) {
        return null;
    }

    return (
        <div
            className={classes.container}
            onClick={openUserProfile}
            data-testid="profile-mobile-cta"
        >
            <div className={classes.userInfoSection}>
                <UserIcon size="XX-Large" photoUrl={currentUser.photoUrl} />
                <div className={classes.userInfoColumn}>
                    <UserFullName
                        firstName={currentUser.firstName}
                        lastName={currentUser.lastName}
                        variant="t71"
                        clamp={1}
                    />
                    <UserJobDetails
                        role={currentUser.title}
                        company={currentUser.company}
                        variant="t81"
                        clamp={2}
                        className={classes.userJobText}
                    />
                </div>
            </div>
            <ArrowRightSLine className={classes.arrowIcon} />
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        container: {
            display: 'flex',
            alignItems: 'center',
            paddingBottom: 25,
        },
        arrowIcon: {
            marginLeft: 'auto',
            fontSize: 17,
            transform: 'translateX(6px)',
            color: '#404040', // TODO: use the customization theme
            flexShrink: 0,
        },
        userInfoColumn: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: 12,
        },
        userInfoSection: {
            display: 'flex',
        },
        userJobText: {
            color: transparentize(0.6, '#404040'), // TODO: use the customization theme
        },
    }),
    { classNamePrefix: 'people-user-profile-mobile-cta' }
);
